module.exports = __webpack_public_path__ + "static/img/people1.5f7b72fd.png";